import { Component, Input, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DealsType01Component } from "../../deals/deals-type01/deals-type01.component";
import { Router, RouterLink } from '@angular/router';
import { CountersType01Component } from "../../counter/counters-type01/counters-type01.component";

import { TFMService } from 'app/mock-api/tfm.service';

@Component({
    selector: 'app-xl-leisure-travel',
    standalone: true,
    imports: [DealsType01Component, RouterLink, CountersType01Component],
    templateUrl: './xl-leisure-travel.component.html',
    styleUrls: ['./xl-leisure-travel.component.css'],
})
export class XlLeisureTravelComponent implements OnInit {

    @Input() isLandingPage: boolean = false;
    @Input() content: string;

    public view: any = {};

    constructor(public _tfmService: TFMService, private router: Router, private metaService: Meta, private title: Title) {
        this._tfmService.getDestinations().then((res) => {
            this.view.destinations = res;
            // console.log(this.view.destinations);
        });

        this._tfmService.getContentBySection('leisure-travel').then(res => {
            this.view.page = res;
            // console.log(res);
            this._tfmService.log(this.view);

            if (this.view.page?.content.rawContent) {
                this.content = this.view.page?.content.rawContentShort
            }

            if (this.view.page?.content.metaData) {
                this.view.metaDataContent = JSON.parse(this.view.page.content.metaData).general;
                // console.log(this.view.metaDataContent);
            }
        });
    }

    ngOnInit() {
        this._tfmService.getSite().then(res => {
            this.view.site = res;

            this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
            this._tfmService.log(this.view);

        });
    }

    openPackages() {
        this.router.navigate(['packages']);
    }

    openBlackFridayPackages() {
        this.router.navigate(['packages/black-friday-specials']);
    }
}
